import { ImageList, Typography } from '@mui/material';
import EmptyMessage from 'core/components/EmptyMessage';
import { longDateFormatter } from 'core/utils/commonUtils';
import useResponsive from 'hooks/useResponsive';
import { groupBy, isEmpty, isNil, map } from 'lodash';
import { Fragment, type FC } from 'react';
import GalleryImage from './GalleryImage';
import type { OrderImage } from 'models/order/orderImage';

interface OrderImageListProps {
  images: OrderImage[];
  onImageClick?: (index: number) => void;
  onImageDelete?: (item: OrderImage) => void;
}

const OrderImageList: FC<OrderImageListProps> = ({
  images,
  onImageClick,
  onImageDelete,
}) => {
  // const isSmallScreen = useResponsive('down', 'md');
  const sm = useResponsive('up', 'sm');
  const md = useResponsive('up', 'md');
  const lg = useResponsive('up', 'lg');
  const xl = useResponsive('up', 'xl');

  // const variant = isSmallScreen ? 'standard' : 'masonry';

  const imageGroups = groupBy(images, (img) => longDateFormatter.format(img.date));

  const listColsCount = xl ? 7 : lg ? 5 : md ? 4 : sm ? 3 : 2;

  let groupIndex = 0;

  if (isEmpty(imageGroups)) {
    return <EmptyMessage />;
  }

  return (
    <>
      {map(imageGroups, (g, d) => {
        const items = (
          <Fragment key={d}>
            <Typography variant='subtitle2'>{d}</Typography>
            <ImageList variant={'standard'} cols={listColsCount} gap={8}>
              {g.map((item, i) => {
                const globalIndex = i + groupIndex;
                return (
                  <GalleryImage
                    key={`${item.name}${i}`}
                    src={item.thumbnailUrl}
                    alt={item.name}
                    onDelete={
                      isNil(onImageDelete)
                        ? undefined
                        : () => {
                            onImageDelete(item);
                          }
                    }
                    onImageClick={() => {
                      !isNil(onImageClick) && onImageClick(globalIndex);
                    }}
                  />
                );
              })}
            </ImageList>
          </Fragment>
        );

        groupIndex += g.length;

        return items;
      })}
    </>
  );
};

export default OrderImageList;
